import { motion, AnimatePresence, useReducedMotion } from "motion/react";

const colors = {
  error: "var(--mesa-error)",
  inactive: "var(--mesa-warn)",
  sent: "var(--mesa-success)",
  empty: "var(--text-secondary)",
  warning: "var(--mesa-warn)"
};

const dotColors = {
  error: "#ff6b6b",
  inactive: "#ffd166",
  sent: "#5aff5a",
  empty: "var(--text-secondary)",
  warning: "#ffd166"
};

export default function StatusNotice({ type, title, message, action }) {
  const reduced = useReducedMotion();
  return (
    <AnimatePresence>
      <motion.div
        className="mesa-status-notice"
        style={{ borderColor: colors[type] || colors.warning }}
        initial={reduced ? undefined : { opacity: 0, y: 10 }}
        animate={reduced ? undefined : { opacity: 1, y: 0 }}
        exit={reduced ? undefined : { opacity: 0, y: 10 }}
        transition={{ duration: 0.2 }}
      >
        <span
          className="mesa-status-dot"
          style={{ background: dotColors[type] || dotColors.warning }}
          aria-hidden="true"
        />
        <div>
          {title && <strong>{title}</strong>}
          {message && <p>{message}</p>}
          {action}
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
